import React from 'react'
import { CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { AsyncStatus } from 'consts'
import usePatientNotes from 'hooks/RTK/usePatientNotes'
import NotesList from '../PatientSwitchableView/Notes/NotesList'

const useStyles = makeStyles(theme => ({
  container: {
    padding: 10
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))

const PatientNotes = () => {
  const classes = useStyles()

  const { notes, status: notesLoadStatus } = usePatientNotes()

  return (
    <div className={classes.container}>
      {notesLoadStatus === AsyncStatus.Loading ? (
        <div className={classes.loader}>
          <CircularProgress size={24} />
        </div>
      ) : (
        <NotesList notes={notes} />
      )}
    </div>
  )
}

export default PatientNotes
